import { render, staticRenderFns } from "./delete-today.vue?vue&type=template&id=0a8957cc&"
import script from "./delete-today.vue?vue&type=script&lang=js&"
export * from "./delete-today.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports